export enum StepModel {
    PATIENT,
    DEFINITIONS,
    ACTIVES,
    SUBCLASS,
    VEHICLES,
    PRODUCTS,
    DOSAGE,

    // ORAL FLOW
    DEFINITIONS_ORAL,
    ACTIVES_ORAL,
    DOSAGE_ORAL,
}
